import { render, staticRenderFns } from "./SimpleModal.vue?vue&type=template&id=4170715f&scoped=true&"
import script from "./SimpleModal.vue?vue&type=script&lang=js&"
export * from "./SimpleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4170715f",
  null
  
)

export default component.exports